import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { connect } from 'react-redux';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import EventForm from './EventForm';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import './Events.scss';
import { getRegions } from '../../../../../Redux/Actions/CommonActions';
import { formatDate } from '@telerik/kendo-intl'
import GridDateLocaleTimeFormatter from '../../../GridDateLocaleTimeFormatter';
import axios from 'axios';
import { EventsLoader } from './EventsLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

const FileDownload = require('js-file-download');

class ManageEvents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            eventInEdit: {},
            isPopupVisible: false,
            events: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "isActive", operator: "eq", value: true }]
                },
                sort: []
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    dataStateChange = (e) => {
        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].field && (filters[i].field == "startDate" || filters[i].field == "endDate")) {
                    var operator = filters[i].operator;

                    if ((operator == "gt" || operator == "gte") && !filters[i].value) {

                        filters[i].value = new Date('January 01, 1900');

                    } else if ((operator == "lt" || operator == "lte") && !filters[i].value) {

                        var currentDatetime = new Date();

                        filters[i].value = new Date(Date.UTC(currentDatetime.getFullYear(), currentDatetime.getMonth(), currentDatetime.getDate()));

                    }
                } else if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (eventsFetched) => {
        this.setState({
            ...this.state,
            events: eventsFetched,
            isLoading: false
        });

        if (eventsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (eventsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        var data = Object.assign({}, dataItem);
        let eventCategory = {
            id: dataItem.eventCategoryID,
            name: dataItem.eventCategory
        };
        let region = {
            id: dataItem.regionId,
            name: dataItem.region,
        };
        let district = {
            id: dataItem.districtId,
            name: dataItem.district
        };
        let state = {
            id: dataItem.stateId,
            name: dataItem.state
        };

        data["eventCategory"] = eventCategory;
        data["region"] = region;
        data["district"] = district;
        data["state"] = state;
        this.setState({
            eventInEdit: data,
            isPopupVisible: true
        });
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                if (element["field"] == "OrderDate") {
                    let date = element.value;
                    if (!date) {
                        date = "01/01/0001";
                    }
                    else {
                        date = (date + '').split(" ");
                        let day = date[2] + '';
                        let year = date[3] + '';
                        let month = "01";
                        switch (date[1]) {
                            case "Jan":
                                month = "01";
                                break;
                            case "Feb":
                                month = "02";
                                break;
                            case "Mar":
                                month = "03";
                                break;
                            case "Apr":
                                month = "04";
                                break;
                            case "May":
                                month = "05";
                                break;
                            case "Jun":
                                month = "06";
                                break;
                            case "Jul":
                                month = "07";
                                break;
                            case "Aug":
                                month = "08";
                                break;
                            case "Sep":
                                month = "09";
                                break;
                            case "Oct":
                                month = "10";
                                break;
                            case "Nov":
                                month = "11";
                                break;
                            case "Dec":
                                month = "12";
                                break;
                        }
                        date = month + "/" + day + "/" + year;
                        element["value"] = date;
                    }
                }
                else {
                    for (var key in t[i]) {
                        element[key] = element[key] + '';
                    }
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageEvents/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Events.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                // console.log(err);
                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    }

    toggleActive = (dataItem) => {
        dataItem.IsActive = !dataItem.IsActive;
        this.setState({
            isSubmitted: true,
            isLoading: true
        });
        axios
            .post(`${ROOT_API_URL}/ManageEvents/ToggleEvent`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false,
                    isLoading: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to deactivated the event.';

                // console.log(err);
                this.setState({
                    isSubmitted: false,
                    isLoading: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    };

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            eventInEdit: {}
        });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "isActive", operator: "eq", value: true }]
                },
                sort: []
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageEvents/SaveEvent`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the event.';

                // console.log(err);
                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"events-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading events" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                                //style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.events.total}
                                {...this.state.dataState}
                                {...this.state.events}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageEvents/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="title" title="Title" filter="text" />
                                <Column field="location" title="Location" filter="text" />
                                <Column field="address1" title="Address" filter="text" />
                                <Column field="city" title="City" filter="text" />
                                <Column field="externalURL" title="External URL" />
                                <Column field="externalURLLabel" title="External URL Label" />
                                <Column field="startDate" title="Start Date" cell={GridDateLocaleTimeFormatter} filter="date"/>
                                <Column field="endDate" title="End Date" cell={GridDateLocaleTimeFormatter} filter="date"/>
                                <Column field="isActive" title="Active event" width="150vw" filter="boolean"/>
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <EventsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <EventForm
                                dataItem={this.state.eventInEdit}
                                allEvents={this.state.events}
                                save={this.save}
                                cancel={this.cancel}
                            />
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}


//this.props.events 
//this.props.common 
function mapStateToProps(state) {
	return {
		event: state.event,
		common: state.common
	};
}

export default connect(mapStateToProps, {
	getRegions,
	toastr
})(ManageEvents);
